import { CommonButtonProps, StandardButton } from './StandardButton'

const ClassButton: React.FC<CommonButtonProps> = ({ id, active, disabled, onClick }) => (
    <StandardButton
        id={id}
        color={active ? 'primary' : 'secondary'}
        iconSrc={'SchoolRounded'}
        disabled={disabled}
        onClick={onClick}
        text={!active ? 'Return to Class' : 'Class'}
    />
)

export { ClassButton }
